import script from "./ResultsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultsView.vue?vue&type=script&setup=true&lang=js"

import "./ResultsView.vue?vue&type=style&index=0&id=0030638c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0030638c"]])

export default __exports__